module.exports = __webpack_public_path__ + "img/logo_polygon.11a73b15.png";